// extracted by css-extract-rspack-plugin
export default {"field":"a2_Eitp8m1sP_9hT"};